import * as React from "react";

import { Confirm, CostCenter } from "./Chapters";

export default (key, method) => {
  switch (key) {
    case "COST_CENTER":
      return <CostCenter {...{ method }} />;
    default:
      return <Confirm {...{ method }} />;
  }
};
